export default "__VITE_ASSET__CTeqy4UG__"